import { onMounted, onUnmounted, unref } from 'vue';

/**
 * Calls a handler function when a click occurs outside the target element.
 *
 * @param {import('vue').Ref<HTMLElement | null> | HTMLElement} target - The target element ref or the element itself.
 * @param {function(event: PointerEvent): void} handler - The function to call when a click outside occurs.
 */
export function useOnClickOutside(target, handler) {
  const listener = event => {
    const el = unref(target);

    // Do nothing if target element doesn't exist or is clicked directly
    if (!el || el.contains(event.target)) {
      return;
    }

    handler(event);
  };

  onMounted(() => {
    document.addEventListener('pointerdown', listener, { passive: true });
  });

  onUnmounted(() => {
    document.removeEventListener('pointerdown', listener);
  });
}
